import {AppState} from '@app/context/context';
import {searchColumnsStorage} from '@app/storage/searchColumnsStorage';

export interface UpdateSearchConfigEvent {
    config: Partial<AppState['search']['config']>;
}

export function emitSearchConfigUpdate(
    setState: React.Dispatch<React.SetStateAction<AppState>>,
    event: UpdateSearchConfigEvent & {isSavedConfig?: boolean}
) {
    setState((prevState: AppState) => {
        const updatedConfig = {
            ...prevState.search.config,
            ...event.config
        };

        if (event.isSavedConfig) {
            searchColumnsStorage.set(updatedConfig);
        }

        return {
            ...prevState,
            search: {
                ...prevState.search,
                config: updatedConfig
            }
        };
    });
}
